import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import * as Sentry from '@sentry/react';

import App from './App';
import { setupAxios } from './_metronic';
import store, { persistor } from './app/store/store';

import './index.scss';
import 'socicon/css/socicon.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './_metronic/_assets/plugins/line-awesome/css/line-awesome.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';

const API_URL = import.meta.env.VITE_API_URL;
const PUBLIC_URL = import.meta.env.BASE_URL;

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

setupAxios(axios, store);

Sentry.init({
  dsn: 'https://1552609f8b894006957263838cfea750@o47564.ingest.sentry.io/5972913',
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <App
    store={store}
    persistor={persistor}
    basename={PUBLIC_URL}
  />,
  document.getElementById('root')
);